import React from "react";
import PageLayout from "./PageLayout";
import Hero from "../components/homepage/Hero";
import Features from "../components/homepage/Features";
import ApartmentPhotos from "../components/homepage/ApartmentPhotos";
import Activities from "../components/homepage/Activities";
import InfoContent from "../components/homepage/InfoContent";
import "./Homepage.css";
import MapLocation from "../components/homepage/MapLocation";

const Homepage = () => {
  return (
    <PageLayout fullWidthContent={<Hero />}>
      <div style={{ position: "relative", marginTop: "0px", marginBottom: "64px", zIndex: 1 }}>
        <InfoContent />
        <ApartmentPhotos />
        <MapLocation />
        <Activities />

      </div>
    </PageLayout>
  );
};

export default Homepage;
